export default __webpack_public_path__ + "static/media/FinishBase.df35ce37.png";